import { getShortDate } from '../wix-design-systems-locale-utils';
export const getFilter = (validation)=>{
    const minimum = validation?.string?.dateOptions?.minimum;
    const maximum = validation?.string?.dateOptions?.maximum;
    if (minimum) {
        return (date)=>date > new Date();
    }
    if (maximum) {
        return (date)=>date < new Date();
    }
    return undefined;
};
export const formatDate = (date)=>{
    if (date) {
        const _date = new Date(date);
        const year = _date.getFullYear();
        const month = (_date.getMonth() + 1).toString().padStart(2, '0');
        const day = _date.getDate().toString().padStart(2, '0');
        return [
            year,
            month,
            day
        ].join('-');
    }
    return null;
};
export const getUTCDate = (dateString)=>{
    const dateStringWithSlashes = dateString.replace(/-/g, '/');
    const _date = new Date(dateStringWithSlashes);
    const dateWithoutHours = new Date(_date.setHours(0, 0, 0, 0));
    return dateWithoutHours;
};
export const getLocalizedValue = (value, locale = 'en')=>{
    return getShortDate(locale, getUTCDate(value));
};

//# sourceMappingURL=date-picker-utils.js.map